import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import styles from "./ProfileLocked.module.scss";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { profileTypeEndPoint } from "../ProfileHeader/profile-enum";
import { useState } from "react";

const ProfileLocked = ({ key = "Port Profile", countries = "Intel Enterprise Logistics", heading = "", imgUrl = "", profileName = "Port" }) => {
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const [buttonClicked, setButtonClicked] = useState(false);
  const handleGetInTouchSubmit = () => {
    setButtonClicked(true);
    const { user_active_plan } = creditDetails.data?.[0] ?? "";
    const planId = user_active_plan;
    const params = {
      planId,
      countries,
      key,
    };
    axios
      .get(profileTypeEndPoint.getInTouch, { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message ? res.data.message : "Something went wrong. Please try again later !!!");
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again later !!!");
      });
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg`} className={styles.boltImage} />
        <div className={styles.right}>
          <p className={styles.heading}>{heading}</p>
          <p>Connect with your dedicated account manager to gain exclusive access to the {profileName} profiles</p>
          <button onClick={handleGetInTouchSubmit} className={`${styles.getInTouchBtn} ${buttonClicked && styles.getInTouchBtnClicked}`} disabled={buttonClicked}>
            Get in touch
          </button>
        </div>
      </div>

      <div className={styles.content}>
        <img src={`${CLOUDINARY_INTEL_BASE_URL}/${imgUrl}`} />
      </div>
    </div>
  );
};

export default ProfileLocked;
